var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchuerze(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.616,
    height: 54.616,
    viewBox: "0 0 54.616 54.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_166",
    x: 0,
    y: 0,
    width: 54.616,
    height: 54.616,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.298
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "schuerze",
    transform: "translate(9 3.712)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -3.71)",
    filter: "url(#Pfad_166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_166-2",
    "data-name": "Pfad 166",
    d: "M66.616,72.308A18.308,18.308,0,1,0,48.308,90.616,18.308,18.308,0,0,0,66.616,72.308",
    transform: "translate(-21 -48)",
    fill: "#dbf1f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_167",
    "data-name": "Pfad 167",
    d: "M37.3,29.588V40.431H34.8V29.864a3.307,3.307,0,0,0-2.5-3.205v16.9H11.007v-16.9a3.308,3.308,0,0,0-2.5,3.205V40.431H6V29.588a6.265,6.265,0,0,1,4.645-6.047l.1-.024a6.264,6.264,0,0,0,4.645-6.047V12.26a6.26,6.26,0,0,1,12.52,0v5.209a6.264,6.264,0,0,0,4.645,6.047l.1.024A6.264,6.264,0,0,1,37.3,29.588M25.406,15.39V12.26a3.756,3.756,0,0,0-7.512,0v3.13Z",
    transform: "translate(-3.317 -5.53)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_168",
    "data-name": "Pfad 168",
    d: "M26.762,38.5H5.478a.469.469,0,0,1-.47-.47V21.8a2.832,2.832,0,0,0-1.565,2.534V34.9a.469.469,0,0,1-.47.47H.47A.469.469,0,0,1,0,34.9V24.057a6.742,6.742,0,0,1,4.993-6.5l.01,0,.095-.023A5.8,5.8,0,0,0,9.39,11.938V6.73a6.73,6.73,0,0,1,13.459,0v5.209a5.8,5.8,0,0,0,4.292,5.593l.095.023.01,0a6.742,6.742,0,0,1,4.993,6.5V34.9a.47.47,0,0,1-.47.47h-2.5a.469.469,0,0,1-.47-.47V24.333A2.832,2.832,0,0,0,27.232,21.8V38.03a.47.47,0,0,1-.47.47M5.947,37.561H26.293V21.128a.469.469,0,0,1,.584-.455,3.771,3.771,0,0,1,2.859,3.661v10.1H31.3V24.057a5.8,5.8,0,0,0-4.292-5.593l-.095-.023-.01,0a6.742,6.742,0,0,1-4.993-6.5V6.73a5.791,5.791,0,0,0-11.581,0v5.209a6.742,6.742,0,0,1-4.993,6.5l-.01,0-.095.023A5.8,5.8,0,0,0,.939,24.057V34.431H2.5v-10.1a3.771,3.771,0,0,1,2.859-3.661.469.469,0,0,1,.584.455ZM5.215,17.986h0Z",
    transform: "translate(2.212 0)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_169",
    "data-name": "Pfad 169",
    d: "M159.982,39.825H152.47a.47.47,0,0,1-.47-.47v-3.13a4.226,4.226,0,0,1,8.451,0v3.13a.47.47,0,0,1-.47.47m-7.043-.939h6.573V36.226a3.287,3.287,0,1,0-6.573,0Z",
    transform: "translate(-137.893 -29.496)",
    fill: "#303e58"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchuerze);
export default __webpack_public_path__ + "static/media/schuerze.0445fed6b498bf219406556e02532119.svg";
export { ForwardRef as ReactComponent };